import { render, staticRenderFns } from "./DeletePuertaModal.vue?vue&type=template&id=2b2964ca"
import script from "./DeletePuertaModal.vue?vue&type=script&lang=js"
export * from "./DeletePuertaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports